import React, { useEffect, useState } from 'react';
import { Button, Form, Select, Modal, message, notification, Spin, Row, Col, Card, Divider, Switch } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { awsService, dropdownService, vehicleService } from '../../../../services';
import { VEHICLES } from '../../../../constants';
import { useNavigate } from 'react-router-dom';
import ImageUploader from '../../../../components/ImageUploader';
import MaterialLikeSelect from '../../../../components/MaterialLikeSelect';
import MaterialLikeInput from '../../../../components/MaterialLikeInput';
import MaterialLikeDatePicker from '../../../../components/MaterialLikeDatePicker';
import dayjs from 'dayjs';

const car_status = [
  { value: "AT YARD", label: "AT YARD" },
  { value: "LOAD PLAN", label: "LOAD PLAN" },
  { value: "LOADED", label: "LOADED" },
  { value: "RETURNED", label: "RETURNED" },
];

const type = [
  { value: "Car", label: "Car" },
  { value: 'Bike', label: "Bike" },
  { value: "General Cargo", label: "General Cargo" },
  { value: "Boat", label: "Boat" },
  { value: "Heavy Equipment", label: "Heavy Equipment" },
  { value: "Miscellaneous", label: "Miscellaneous" }
];

const engine = [
  { value: "GASOLINE", label: "GASOLINE" },
  { value: "HYBRID", label: "HYBRID" },
  { value: "EV", label: "EV" },
];

const Bos = [
  { value: "Auction", label: "Auction" },
  { value: "Notarized", label: "Notarized" },
  { value: "Non-Notarized", label: "Non-Notarized" },
];

const AT_YARD = car_status[0].value;

const keys = [
  { value: "YES", label: "YES" },
  { value: "NO", label: "NO" },
  { value: "BROKEN", label: "BROKEN" },
];

const title = [
  { value: "YES", label: "YES" },
  { value: "NO", label: "NO" },
];

function BetaVersion() {
  const navigate = useNavigate();
  const didInit = React.useRef(false);

  const [activeRowId, setActiveRowId] = useState(null);
  const [expandedCards, setExpandedCards] = useState([]);

  const [loading, setLoading] = useState(false);
  const [appointmentLoading, setAppointmentLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);

  const [customers, setCustomers] = useState([]);
  const [cars, setCars] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null);
  const [vehicleData, setVehicleData] = useState([{
    Id: "",
    status: "AT YARD",
    user_id: "",
    Lot_no: "",
    CuttingCar: false,
    make: "",
    model: "",
    delivery_type: "",
    EngineType: "",
    year: "",
    vin: "",
    DateRcd: "",
    Value: "",
    Weight: "",
    OperatingPort: "",
    BOS: "",
    TitleOwner: "",
    Title: "",
    TitleNumber: "",
    isKey: "",
    Notes: "",
    FileRef: "",
    FileUpload: null,
  }]);
  const REQUIRED_FIELDS = [
    "user_id",
    "vin",
    "year",
    "make",
    "model",
    "status",
    "FileRef"
  ];
  const isVehicleValid = (vehicle) => {
    return REQUIRED_FIELDS.every(field => {
      const value = vehicle[field];
      return value !== undefined && value !== null && String(value).trim() !== "";
    });
  };

  const isFormValid = vehicleData.every(isVehicleValid);

  const [first_id, setFirst_id] = useState();
  const [vin, setVin] = useState([]);
  const [selectedVin, setSelectedVin] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [fromLoading, setFromLoading] = useState(false)

  const [globexCustomer, setGlobexCustomer] = useState([])

  const activeVehicle = vehicleData.find(vehicle => vehicle.Id === activeRowId);
  const activeFileList = activeVehicle?.FileUpload || [];

  const toggleExpand = (id) => {
    setExpandedCards(prev =>
      prev.includes(id)
        ? prev.filter(cardId => cardId !== id)
        : [...prev, id]
    );
  };

  const getNextFileRef = (baseFileRef = "", existingFileRefs = [], opts = { alwaysIncrementBase: false }) => {
    if (!baseFileRef) return "";

    const m = String(baseFileRef).match(/^(.+?)(\d+)$/);
    if (!m) return baseFileRef;

    const prefix = m[1];
    const baseNum = parseInt(m[2], 10);
    const baseNumLen = m[2].length;
    const reg = new RegExp(`^${prefix}(\\d+)$`);

    const nums = existingFileRefs
      .map(fr => {
        if (!fr) return null;
        const mm = String(fr).match(reg);
        return mm ? parseInt(mm[1], 10) : null;
      })
      .filter(n => n != null);

    let nextNum;
    if (nums.length === 0) {
      nextNum = opts.alwaysIncrementBase ? baseNum + 1 : baseNum;
    } else {
      const maxExisting = Math.max(...nums);
      const maxNum = Math.max(maxExisting, baseNum);
      nextNum = maxNum + 1;
    }

    const nextNumStr = String(nextNum).padStart(baseNumLen, "0");
    return `${prefix}${nextNumStr}`;
  };

  const resequenceFileRefs = (vehicles) => {
    const grouped = {};

    vehicles.forEach(v => {
      if (!v.user_id) return;
      if (!grouped[v.user_id]) grouped[v.user_id] = [];
      grouped[v.user_id].push(v);
    });

    Object.keys(grouped).forEach(userId => {
      const customerVehicles = grouped[userId];

      // keep order stable
      customerVehicles.sort((a, b) => a.Id - b.Id);

      const customer = customers.find(c => c.id === Number(userId));
      if (!customer) return;

      const baseRef = customer.last_file_ref || customer.file_ref;
      if (!baseRef) return;

      const match = String(baseRef).match(/^(.+?)(\d+)$/);
      if (!match) return;

      const prefix = match[1];
      const baseNumber = parseInt(match[2], 10);
      const length = match[2].length;

      customerVehicles.forEach((vehicle, index) => {
        const newNumber = customer.last_file_ref
          ? baseNumber + index + 1   // if last_ref exist start +1
          : baseNumber + index;      // if only file_ref exist start same

        vehicle.FileRef = `${prefix}${String(newNumber).padStart(length, "0")}`;
        vehicle.FileRefReadonly = true;
      });
    });

    return [...vehicles];
  };

  const handleInputChange = (value, vehicleId, field) => {
    setVehicleData(prev =>
      prev.map(vehicle => {
        if (vehicle.Id !== vehicleId) return vehicle;

        const updatedVehicle = { ...vehicle, [field]: value };

        if (field === "user_id") {
          const selected = customers.find(c => c.id === value);

          updatedVehicle.isGlobex = selected?.is_globex_customer === 1;
          updatedVehicle.is_globex_vehicle = selected?.is_globex_customer === 1 ? 1 : 0;

          updatedVehicle.globex_customer_id = null;
          updatedVehicle.globex_customer_name = null;

          if (!selected) {
            updatedVehicle.FileRef = "";
            updatedVehicle.FileRefReadonly = false;
            return updatedVehicle;
          }

          const lastRef = selected.last_file_ref ?? null;
          const fileRef = selected.file_ref ?? null;
          const baseRef = lastRef || fileRef || null;

          if (!baseRef) {
            updatedVehicle.FileRef = "";
            updatedVehicle.FileRefReadonly = false;
            return updatedVehicle;
          }

          const existingFileRefs = prev
            .filter(v => v.Id !== vehicleId)
            .map(v => v.FileRef)
            .filter(Boolean);

          const alwaysIncrement = !!lastRef;
          const nextFileRef = getNextFileRef(baseRef, existingFileRefs, { alwaysIncrementBase: alwaysIncrement });

          updatedVehicle.FileRef = nextFileRef;
          updatedVehicle.FileRefReadonly = true;
        }

        return updatedVehicle;
        // const updatedList = prev.map(vehicle =>
        //   vehicle.Id === vehicleId ? updatedVehicle : vehicle
        // );
        // return resequenceFileRefs(updatedList);
      })
    );
  };

  const handleSelectChange = (value) => {
    const selectedCar = cars.find((car) => car.id === value);
    setSelectedCar(selectedCar);
  };

  const addVehicle = () => {
    setVehicleData((prevData) => {
      const newId = prevData.length > 0 ? prevData[prevData.length - 1].Id + 1 : first_id;
      const newVehicle = {
        Id: newId,
        status: AT_YARD,
        user_id: "",
        Lot_no: "",
        CuttingCar: false,
        make: "",
        model: "",
        delivery_type: "",
        EngineType: "",
        year: "",
        vin: "",
        DateRcd: "",
        Value: "",
        Weight: "",
        OperatingPort: "",
        BOS: "",
        TitleOwner: "",
        Title: "",
        TitleNumber: "",
        isKey: "",
        Notes: "",
        FileRef: "",
        FileUpload: [],
        isGlobex: false,
        is_globex_vehicle: 0,
        globex_customer_id: null,
        globex_customer_name: null,
      };

      return [...prevData, newVehicle];
    });
  };

  const getAppointedCars = async () => {
    setAppointmentLoading(true);
    const response = await dropdownService.fetchApprovedCars();
    if (response.success) {
      setCars(response.data);
    }
    setAppointmentLoading(false);

  };

  const handleAdd = () => {
    const isDuplicateVin = vehicleData.some((vehicle) => vehicle.vin === selectedCar.vin);

    if (isDuplicateVin) {
      message.error("This VIN number already exists.");
      return;
    }

    if (selectedCar && vehicleData.length > 0) {
      setVehicleData((prevData) => {
        const emptyVehicleIndex = prevData.findIndex(
          (vehicle) => !vehicle.make && !vehicle.model && !vehicle.vin
        );

        const targetIndex = emptyVehicleIndex !== -1 ? emptyVehicleIndex : prevData.length - 1;
        const { id, status: AT_YARD, ...selectedCarData } = selectedCar;

        const updatedData = [...prevData];
        updatedData[targetIndex] = {
          ...updatedData[targetIndex],
          ...selectedCarData,
        };

        return updatedData;
      });
    }
  };

  const getLatestId = async () => {
    setLoading(true);
    const response = await vehicleService.getLatestID();
    setLoading(false);
    if (response.success) {
      const latestId = response.data[0].highest_id + 1;
      // const initialVehicle = {
      //   Id: latestId,
      //   status: "AT YARD",
      //   user_id: "",
      //   Lot_no: "",
      //   CuttingCar: false,
      //   make: "",
      //   model: "",
      //   delivery_type: "",
      //   EngineType: "",
      //   year: "",
      //   vin: "",
      //   DateRcd: "",
      //   Value: "",
      //   Weight: "",
      //   OperatingPort: "",
      //   BOS: "",
      //   TitleOwner: "",
      //   Title: "",
      //   TitleNumber: "",
      //   isKey: "",
      //   Notes: "",
      //   FileRef: "",
      //   FileUpload: [],
      //   isGlobex: false,
      //   is_globex_vehicle: 0,
      //   globex_customer_id: null,
      //   globex_customer_name: null,
      // };

      setVehicleData(prev =>
        prev.map((item, index) =>
          index === 0
            ? { ...item, Id: latestId }
            : item
        )
      );
      // setVehicleData([initialVehicle]);
      setFirst_id(latestId);
    }
  };

  const handleDeleteVehicle = (Id) => {
    setVehicleData((prev) => {
      const filtered = prev.filter(v => v.Id !== Id);

      const baseId = Math.min(...filtered.map(v => v.Id));
      const reIndexed = filtered.map((v, index) => ({
        ...v,
        Id: baseId + index,
      }));

      return resequenceFileRefs(reIndexed);
    });
  };

  const handleImagesAdd = () => {
    if (!selectedVin) {
      return message.error("Please select a VIN number first.");
    }

    const selectedCar = vin.find((car) => car.id === selectedVin);

    if (!selectedCar?.images || selectedCar.images.length === 0) {
      return message.warning("No images found for the selected VIN.");
    }

    const fakeFileObjects = selectedCar.images.map((url, index) => ({
      uid: `-${Date.now()}-${index}`,
      name: `image_${index}.jpg`,
      status: 'done',
      url,
      thumbUrl: url,
      originFileObj: {
        name: `image_${index}.jpg`,
        status: 'done',
        type: "existing",
      },
    }));

    setVehicleData(prev =>
      prev.map(vehicle =>
        vehicle.Id === activeRowId
          ? {
            ...vehicle,
            FileUpload: [
              ...(vehicle.FileUpload || []),
              ...fakeFileObjects,
            ],
          }
          : vehicle
      )
    );

    message.success("Images added.");
  };

  const onFinish = async () => {
    const missing = vehicleData
      .filter(v => !v.FileRef || String(v.FileRef).trim() === "")
      .map(v => v.Id);

    if (missing.length > 0) {
      message.error(
        `Customer has no File Ref in the system.\nPlease contact management to add the File Ref for this customer.\n(Affected vehicle(s): ${missing.join(", ")})`
      );
      return;
    }

    setFromLoading(true);
    try {
      const newData = await Promise.all(
        vehicleData.map(async (vehicle) => {
          let formData = {
            BOS: vehicle.BOS,
            car_status: vehicle.status,
            chasis_no: vehicle.vin,
            cutting_car: vehicle.CuttingCar ? 1 : 0,
            date_rcd: vehicle.DateRcd,
            engine_type: vehicle.EngineType,
            file_ref: vehicle.FileRef,
            keys: vehicle.isKey,
            "lot_#": vehicle.Lot_no,
            notes: vehicle.Notes,
            operating_port: vehicle.OperatingPort,
            product: vehicle.make,
            title: vehicle.Title,
            title_number: vehicle.TitleNumber,
            title_owner: vehicle.TitleOwner,
            user_id: vehicle.user_id,
            value: vehicle.Value,
            vehicle: vehicle.model,
            vehicle_type: vehicle.delivery_type,
            weight: vehicle.Weight,
            year: vehicle.year,
            FileUpload: vehicle.FileUpload,
          };

          const vehicleImages = formData.FileUpload || [];
          const existingImages = vehicleImages.filter(file => file.originFileObj?.type === "existing");
          const newImages = vehicleImages.filter(file => file.originFileObj?.type !== "existing");
          const existingImageUrls = existingImages.map(file => file.url);

          formData.vehicle_uploaded_id = selectedVin;
          formData.vehicle_uploaded_images = existingImageUrls;

          if (vehicle.is_globex_vehicle === 1) {
            formData.is_globex_vehicle = 1;
            formData.globex_customer_id = vehicle.globex_customer_id;
            formData.globex_customer_name = vehicle.globex_customer_name;
          }

          if (newImages.length > 0) {
            const userName = customers.find((i) => i.id === vehicle.user_id)?.name ?? "unknown";

            try {
              const uploadedImages = await awsService.uploadS3Bucket(vehicleImages, userName, formData.chasis_no, VEHICLES);
              formData.FileUpload = uploadedImages;
            } catch (error) {
              console.error(`Failed to upload images for ${vehicle.vin}:`, error);
              formData.FileUpload = [];
            }
          } else {
            formData.FileUpload = [];
          }

          return { [vehicle.Id]: formData };
        })
      );

      const requestData = newData.reduce((acc, cur) => ({ ...acc, ...cur }), {});

      const response = await vehicleService.addVehicle(requestData);

      if (response?.success) {
        notification.success({ message: "Added Successfully!", description: response.message, placement: "topRight" });
        navigate('/vehicle');
      } else {
        message.error(response?.message || "Failed to save records.");
      }
    } catch (err) {
      setFromLoading(false);
      console.error(err);
      message.error("An unexpected error occurred while saving.");
    } finally {
      setFromLoading(false);
    }
  };

  const getCustomer = async () => {
    setCustomerLoading(true);
    const response = await dropdownService.fetchCustomers();
    setCustomerLoading(false);
    if (response.success) {
      const filter = response.data.sort((a, b) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      );

      const capitalizedFilter = filter.map((customer) => ({
        ...customer,
        name: customer.name.toUpperCase(),
      }));
      setCustomers(capitalizedFilter);
    }
  };

  const getGlobexCustomer = async () => {
    const response = await dropdownService.fetchGlobexCustomer();
    if (response.success) {
      setGlobexCustomer(response.data);
    }
  };

  const getVin = async () => {
    const response = await dropdownService.fetchVin();
    if (response.success) {
      setVin(response.data);
    }
  };

  const handleFileChange = (info) => {
    const { fileList } = info;
    setVehicleData(prev =>
      prev.map(vehicle =>
        vehicle.Id === activeRowId
          ? { ...vehicle, FileUpload: fileList }
          : vehicle
      )
    );
  };

  const handleDeleteAll = () => {
    setVehicleData(prev =>
      prev.map(vehicle =>
        vehicle.Id === activeRowId
          ? { ...vehicle, FileUpload: [] }
          : vehicle
      )
    );
  };

  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;

    getCustomer();
    getLatestId();
    getAppointedCars();
    getVin();
    getGlobexCustomer();
  }, []);

  return (
    <div style={{ padding: "15px", border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#FFFFFF" }}>

      {/* Top Section - Appointment Cars */}
      <div style={{ marginBottom: 6 }}>
        <Form layout="vertical">
          <Row gutter={16}>
            <Col xs={24} sm={10}>
              <Form.Item label="Approved Appointment Cars VIN #">
                <Select
                  optionFilterProp="children"
                  showSearch
                  placeholder="Select Appointment Car"
                  loading={appointmentLoading}
                  notFoundContent={appointmentLoading ? <Spin size="small" /> : null}
                  onChange={(value) => handleSelectChange(value)}
                >
                  {cars.map((car) => (
                    <Select.Option key={car.id} value={car.id}>
                      {car.vin} - {car.make} - {car.model}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={2}>
              <Form.Item label=" " style={{ marginTop: 0 }}>
                <Button type="primary" block onClick={handleAdd}>
                  Add
                </Button>
              </Form.Item>
            </Col>

            <Col xs={24} sm={10}>
              <Form.Item label="VIN No">
                <Select
                  placeholder="Enter VIN No"
                  allowClear
                  onSelect={(value) => setSelectedVin(value)}
                  loading={loading}
                  showSearch
                  optionFilterProp="children"
                >
                  {vin.map((vin) => (
                    <Select.Option key={vin.id} value={vin.id}>{vin.vin}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={2}>
              <Form.Item label=" " style={{ marginTop: 0 }}>
                <Button type="primary" block onClick={handleImagesAdd}>
                  Add
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>



      {/* Vehicle Cards */}
      {vehicleData.map((vehicle, index) => {
        const isExpanded = expandedCards.includes(vehicle.Id);

        return (
          <Card
            key={vehicle.Id}
            style={{ marginBottom: 20, borderRadius: 8, }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 16, fontWeight: 600 }}>
                Vehicle Entry {index + 1}
              </span>
            </div>
            <br />
            {/* Always Visible Fields */}
            <Row gutter={[16, 16]}>
              <Col span={4}>
                <MaterialLikeSelect
                  label="Customer"
                  required
                  value={vehicle.user_id}
                  loading={customerLoading}
                  dropdownStyle={{ width: 200 }}
                  onChange={(value) =>
                    handleInputChange(value, vehicle.Id, "user_id")
                  }
                  options={customers.map(c => ({
                    value: c.id,
                    label: c.name,
                  }))}
                />
                {/* 
                                    {customers?.length > 0 && (
                                        <Select
                                            value={vehicle.user_id}
                                            placeholder="Select Customer"
                                            showSearch
                                            optionFilterProp="children"
                                            onChange={(value) => handleInputChange(value, vehicle.Id, "user_id")}
                                        >
                                            {customers.map(c => (
                                                <Select.Option key={c.id} value={c.id}>
                                                    {c.name}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    )} */}
              </Col>



              <Col span={4}>
                <MaterialLikeInput
                  label="VIN Number"
                  required
                  value={vehicle.vin}
                  onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "vin")}
                />
              </Col>

              <Col span={4}>
                <MaterialLikeInput
                  label="Year"
                  required
                  type="number"
                  value={vehicle.year}
                  onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "year")}
                />
              </Col>

              <Col span={4}>
                <MaterialLikeInput
                  label="Make"
                  required
                  value={vehicle.make}
                  onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "make")}
                />
              </Col>

              <Col span={4}>
                <MaterialLikeInput
                  label="Model"
                  required
                  value={vehicle.model}
                  onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "model")}
                />
              </Col>

              <Col span={4}>
                <MaterialLikeSelect
                  label="Status"
                  required
                  value={vehicle.status || "AT YARD"}
                  onChange={(value) =>
                    handleInputChange(value, vehicle.Id, "status")
                  }
                  options={car_status.map(s => ({
                    value: s.value,
                    label: s.label,
                  }))}
                />
              </Col>

              {vehicle.isGlobex &&
                (<Col span={4}>
                  <MaterialLikeSelect
                    required
                    label="Globex Customer"
                    dropdownStyle={{ width: 200 }}
                    value={vehicle.globex_customer_id}
                    onChange={(value) => {
                      const globex = globexCustomer.find(g => g.id === value);
                      handleInputChange(value, vehicle.Id, "globex_customer_id");
                      handleInputChange(globex?.name || "", vehicle.Id, "globex_customer_name");
                    }}
                    options={globexCustomer.map(g => ({ value: g.id, label: g.name, }))} />
                </Col>)}
            </Row>

            <br />

            <div className='flex justify-between'>
              <Button
                type="default"
                // icon={isExpanded ? <UpOutlined /> : <DownOutlined />}
                onClick={() => toggleExpand(vehicle.Id)}
              >
                {isExpanded ? 'Hide Details' : 'More Details'}
              </Button>
              <div className='flex gap-5'>

                <div className='flex gap-2 items-center'>
                  <label> Cutting </label>
                  <Switch
                    checked={vehicle.CuttingCar}
                    onChange={(checked) => handleInputChange(checked, vehicle.Id, "CuttingCar")}
                  />
                </div>

                {/* Delete Icon */}
                <Button
                  type="primary"
                  danger
                  disabled={vehicleData.length === 1}
                  icon={<DeleteOutlined />}
                  onClick={() => handleDeleteVehicle(vehicle.Id)}
                />

              </div>
            </div>

            <br />

            {/* Expandable Fields */}
            {
              isExpanded && (
                <>
                  <Divider style={{ marginBottom: 20, marginTop: 0 }} />
                  <Row gutter={16}>
                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <MaterialLikeSelect
                          label="Type"
                          value={vehicle.delivery_type}
                          onChange={(value) => handleInputChange(value, vehicle.Id, "delivery_type")}
                          options={type.map(t => ({
                            value: t.value,
                            label: t.label,
                          }))}
                        />

                        {/* <Select
                                                placeholder="Select Type"
                                                value={vehicle.delivery_type}
                                                onChange={(value) => handleInputChange(value, vehicle.Id, "delivery_type")}
                                            >
                                                <Option value="Car">Car</Option>
                                                <Option value="Bike">Bike</Option>
                                                <Option value="Boat">Boat</Option>
                                                <Option value="General Cargo">General Cargo</Option>
                                                <Option value="Heavy Equipment">Heavy Equipment</Option>
                                                <Option value="Miscellaneous">Miscellaneous</Option>
                                            </Select> */}

                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <MaterialLikeSelect
                          label="Keys"
                          value={vehicle.isKey}
                          onChange={(value) => handleInputChange(value, vehicle.Id, "isKey")}
                          options={keys.map(k => ({
                            value: k.value,
                            label: k.label,
                          }))}
                        />
                        {/* <Select
                                                value={vehicle.isKey}
                                                placeholder="Select Keys"
                                                onChange={(value) => handleInputChange(value, vehicle.Id, "isKey")}
                                            >
                                                {keys.map((key) => (
                                                    <Select.Option key={key.value} value={key.value}>
                                                        {key.label}
                                                    </Select.Option>
                                                ))}
                                            </Select> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <MaterialLikeDatePicker
                          label="Date Received"
                          value={vehicle.DateRcd ? dayjs(vehicle.DateRcd) : null}
                          onChange={(date, dateString) =>
                            handleInputChange(dateString, vehicle.Id, "DateRcd")
                          }
                        />
                        {/* <DatePicker
                                                placeholder="YYYY/MM/DD"
                                                style={{ width: '100%' }}
                                                onChange={(date, dateString) => handleInputChange(dateString, vehicle.Id, "DateRcd")}
                                            /> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>

                        <MaterialLikeSelect
                          label="Title"
                          value={vehicle.Title}
                          onChange={(value) => handleInputChange(value, vehicle.Id, "Title")}
                          options={title.map(t => ({
                            value: t.value,
                            label: t.label,
                          }))}
                        />

                        {/* <Input
                                                value={vehicle.Title}
                                                placeholder="Enter Title"
                                                onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "Title")}
                                            /> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <MaterialLikeInput
                          label="Title Number"
                          value={vehicle.TitleNumber}
                          onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "TitleNumber")}
                        />
                        {/* <Input
                                                value={vehicle.TitleNumber}
                                                placeholder="Enter Title Number"
                                                onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "TitleNumber")}
                                            /> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item >
                        <MaterialLikeInput
                          label="Title Owner"
                          value={vehicle.TitleOwner}
                          onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "TitleOwner")}
                        />

                        {/* <Input
                                                value={vehicle.TitleOwner}
                                                placeholder="Enter Title Owner"
                                                onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "TitleOwner")}
                                            /> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <MaterialLikeSelect
                          label="BOS"
                          value={vehicle.BOS}
                          onChange={(value) => handleInputChange(value, vehicle.Id, "BOS")}
                          options={Bos.map(b => ({
                            value: b.value,
                            label: b.label,
                          }))}
                        />
                        {/* <Select
                                                value={vehicle.BOS}
                                                onChange={(value) => handleInputChange(value, vehicle.Id, "BOS")}
                                                placeholder="Select BOS"
                                            >
                                                <Option value="Auction">Auction</Option>
                                                <Option value="Notarized">Notarized</Option>
                                                <Option value="Non-Notarized">Non-Notarized</Option>
                                            </Select> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <MaterialLikeInput
                          label="Weight"
                          value={vehicle.Weight}
                          onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "Weight")}
                        />
                        {/* <Input
                                                value={vehicle.Weight}
                                                placeholder="Enter Weight"
                                                onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "Weight")}
                                            /> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <MaterialLikeInput
                          label="Value"
                          value={vehicle.Value}
                          onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "Value")}
                        />
                        {/* <Input
                                                value={vehicle.Value}
                                                placeholder="Enter Value"
                                                onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "Value")}
                                            /> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item >
                        <MaterialLikeSelect
                          label="Engine Type"
                          value={vehicle.EngineType}
                          onChange={(value) => handleInputChange(value, vehicle.Id, "EngineType")}
                          options={engine.map(e => ({
                            value: e.value,
                            label: e.label,
                          }))}
                        />
                        {/* <Select
                                                placeholder="Select Engine Type"
                                                value={vehicle.EngineType}
                                                onChange={(value) => handleInputChange(value, vehicle.Id, "EngineType")}
                                            >
                                                <Option value="GASOLINE">GASOLINE</Option>
                                                <Option value="HYBRID">HYBRID</Option>
                                                <Option value="EV">EV</Option>
                                            </Select> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item >
                        <MaterialLikeInput
                          label="Operating Port"
                          value={vehicle.OperatingPort}
                          onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "OperatingPort")}
                        />
                        {/* <Input
                                                value={vehicle.OperatingPort}
                                                placeholder="Enter Operating Port"
                                                onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "OperatingPort")}
                                            /> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <MaterialLikeInput
                          label="Notes"
                          value={vehicle.Notes}
                          onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "Notes")}
                        />
                        {/* <Input
                                                value={vehicle.Notes}
                                                placeholder="Enter Notes"
                                                onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "Notes")}
                                            /> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <MaterialLikeInput
                          label="File Ref"
                          required
                          value={vehicle.FileRef || ""}
                          // readOnly={vehicle.FileRefReadonly}
                          // onChange={(e) => !vehicle.FileRefReadonly && handleInputChange(e.target.value, vehicle.Id, "FileRef")}
                          onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "FileRef")}
                        />
                        {/* <Input
                                value={vehicle.FileRef || ""}
                                readOnly={vehicle.FileRefReadonly}
                                placeholder="Enter File Ref"
                                onChange={(e) => !vehicle.FileRefReadonly && handleInputChange(e.target.value, vehicle.Id, "FileRef")}
                            /> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <MaterialLikeInput
                          label="Lot#"
                          value={vehicle.Lot_no}
                          onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "Lot_no")}
                        />
                        {/* <Input
                                                value={vehicle.Lot_no}
                                                placeholder="Enter Lot#"
                                                onChange={(e) => handleInputChange(e.target.value, vehicle.Id, "Lot_no")}
                                            /> */}
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>

                    </Col>

                    <Col xs={24} sm={12} md={8}>
                      <Form.Item>
                        <Button
                          type="primary"
                          block
                          onClick={() => {
                            setActiveRowId(vehicle.Id);
                            setModalVisible(true);
                          }}
                        >
                          {vehicle.FileUpload?.length > 0
                            ? `${vehicle.FileUpload.length} images`
                            : "Upload Images"}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )
            }
          </Card>
        );
      })}

      {/* Save Button */}
      <div className='flex justify-end gap-5 items-center'>
        {!isFormValid && (
          <div style={{ color: "red", marginTop: 8 }}>
            Please fill all required fields then the button is enable (*) field
          </div>
        )}
        <Button type="primary" onClick={onFinish} loading={fromLoading} size="large" disabled={!isFormValid} >
          Save Records
        </Button>
        <Button type="primary" onClick={addVehicle} size="large">
          Add New Vehicle
        </Button>
      </div>

      {/* Image Upload Modal */}
      <Modal
        title="Image Upload"
        open={modalVisible}
        footer={null}
        onCancel={() => {
          setModalVisible(false);
          setActiveRowId(null);
        }}
        width={700}
      >
        <div className="flex justify-end">
          <Button onClick={handleDeleteAll} danger>Delete All Images</Button>
        </div>
        <div className="mb-3">
          <ImageUploader
            fileList={activeFileList}
            beforeUpload={true}
            handleChange={handleFileChange}
            length={100}
            remove={false}
          />
          <div className="flex justify-between items-center p-4 mt-4 border-t border-gray-200">
            <p style={{ border: "1px solid #ccc", padding: "8px", borderRadius: "16px" }}>
              {activeFileList.length} images selected
            </p>
            {activeFileList.length > 0 && (
              <Button type="primary" onClick={() => setModalVisible(false)}>
                Done
              </Button>
            )}
          </div>
        </div>
      </Modal>
    </div >
  );
}

export default BetaVersion;
